import dynamic from 'next/dynamic'

export const DynamicPersonalDataSkeleton = dynamic(() =>
	import('./PersonalDataSkeleton').then(({ PersonalDataSkeleton }) => PersonalDataSkeleton)
)
